import React from 'react'

const SummaryHeaderCell = ({ row }) => (
  <span>{row.value}</span>
)

export default SummaryHeaderCell
